module.exports = __webpack_public_path__ + "static/media/textbook-black.9451e4a1.svg";